(function() {

	"use strict";

	angular.module( "ATMGurus" )

	.service( "FormService", [
		"ApiQuery",
		"$q",
		function( ApiQuery, $q ) {

			var token = undefined;
			var defer = $q.defer();

			/**
			*	generate a token upon invocation
			*
			*/
			function fetchToken() {
				ApiQuery('csrf/token', '', 'GET')
					.then(response => {
						if (response.success) {
							token = response.data.token;
						}
					})
			}

			fetchToken();

			return {
				getToken: function() {
					return token;
				},
				post: function( formType, data ) {
					var defer = $q.defer();
					var headers = {
						'X-Csrf-Token': token
					}
					ApiQuery(formType, data, "POST", headers )
						.then( function( response ) {
							fetchToken();
							defer.resolve( response.data )
						}, function( reason ) {
							fetchToken();
							defer.reject( reason.data )
						})
					return defer.promise
				}
			}
		}
	])

})()


// WEBPACK FOOTER //
// ./src/app/services/FormService.js